<script setup lang="ts">
import { Avatar, Menu } from 'primevue';
import { computed, useTemplateRef } from 'vue';
import type { MenuItem } from 'primevue/menuitem';
import { useAuthStore } from '../store/authStore';
import { storeToRefs } from 'pinia';
import { useLanguageStore } from 'shared/translations/stores/languageStore';

const authStore = useAuthStore();
const avatarMenu = useTemplateRef('avatar-menu');

const languageStore = useLanguageStore();
const { translations } = storeToRefs(languageStore);

const avatarItems = computed<MenuItem[]>(() => [
  {
    label: translations.value.generic.logout,
    async command() {
      await authStore.logout();
    },
  },
]);

function onAvatarClick(ev: Event) {
  const menu = avatarMenu.value;
  if (!menu) return;
  menu.toggle(ev);
}

</script>

<template>
  <div v-if="authStore.isAuthenticated">
    <Avatar
      :label="authStore.initials"
      shape="circle"
      class="user-avatar"
      @click="onAvatarClick($event)"
    ></Avatar>
    <Menu :popup="true" :model="avatarItems" ref="avatar-menu"></Menu>
  </div>
</template>

<style scoped>
  .user-avatar {
    cursor: pointer;
    user-select: none;
  }
</style>
